






















import { Component, Vue, Prop } from 'vue-property-decorator';

import { CommonField } from '../models/form';
import DynamicInfo from './DynamicInfo.vue';

@Component({
  components: {
    DynamicInfo,
  },
})
export default class DynamicInfoComponent extends Vue {
  @Prop({ required: true })
  form_values: Array<CommonField | any>;

  @Prop()
  title?: string;

  get form_chunks_common_field() {
    return this.form_values.filter((field) => this.isCommonField(field));
  }

  get form_chunks_object() {
    return this.form_values
      .filter((field) => !this.isCommonField(field))
      .map((elm) => ({ values: Object.values(elm), title: Object.keys(elm)[0] }));
  }

  isCommonField(field: any): boolean {
    return !!(field as CommonField).label;
  }
}
